// Collects the fields the server needs for conversion firing AND for CRM
// attribution: the paid click ids + first-touch UTMs (persisted in the user
// store), the GA4 client id from the _ga cookie, and the first-touch landing
// timestamp. Spread the result into a form's POST body so every server route
// (contact, book_demo, quiz, content_request, webinar) forwards a consistent,
// complete attribution set to both the ad platforms and Elker Studio.
//
// All fields optional: organic/direct leads have no gclid/msclkid, and both the
// conversion firing and the CRM intake tolerate nulls.
export const useConversionFields = () => {
  const userStore = useUserStore()

  return {
    gclid: userStore.gclid || null,
    msclkid: userStore.msclkid || null,
    gaClientId: readGaClientId(),
    // Extra attribution the CRM (Elker Studio) stores per lead:
    utmTerm: userStore.utmTerm || null,
    utmContent: userStore.utmContent || null,
    firstSeenAt: userStore.firstSeenAt || null, // ISO 8601, first-touch
    referrer: userStore.referrer || null, // first-touch external referrer
  }
}

// The GA4 client id lives in the _ga cookie as 'GA1.1.<clientId>.<timestamp>'.
// The client id GA uses is '<clientId>.<timestamp>'. Returns null server-side or
// when the cookie is absent (e.g. consent not granted).
function readGaClientId() {
  if (typeof document === 'undefined') return null
  // Anchor to a cookie-name boundary (start of string or after "; ") so a
  // cookie whose name merely ends in "_ga" (e.g. "foo_ga") can't be misread as
  // the real "_ga" cookie.
  const match = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.(\d+\.\d+)/)
  return match ? match[1] : null
}
